//Constants
const ONE_MONTH = 30 * 24 * 3600 * 1000;
const ONE_DAY = 24 * 3600 * 1000;
const ONE_HOUR = 3600 * 1000;
const ONE_MINUTE = 60 * 1000;
const TEN_MINUTES = 10 * 60 * 1000;
const SERVER_TIME_DIFFERENCE = 3 * ONE_HOUR;

const PERIOD_MACROS = {
    YESTERDAY: 'yesterday',
    LAST_7_DAYS: 'last7days',
    CURRENT_MONTH: 'currentMonth',
    LAST_MONTH: 'lastMonth'
}

const NANO_AGREEMENT = {
    LOW_CPM: 0.58,
    LOW_CPM_WEBSITES: ["stiripesurse.ro"],
    NO_FIXED_CPM_WEBSITES: ["cinemagia.ro", "protv.md", "perfecte.md", "stiripesurse.md", "dcnews.ro", "zdg.md", "tvn.md"],
    NORMAL_CPM: 1.02
}

//Regex validation
const PASSWORD_VALIDATION_CHECK = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{10,}$/;
const IMAGES_EXTENSIONS_CHECK = /\.(jpg|jpeg|png|gif)$/;

const POSSIBLE_CHART_COLORS = ['#48a5ecff', '#4793e6ff', '#ebce6eff', '#e4883cff', '#4d7c8fff', '#abdbdbff', '#da5234ff', '#4ed3e2ff', '#0ebba4ff'];

const ADMIN_ACCESS = 'ADMIN';
const ADMIN_ACCESS_MASK = 'Gemius';
const PARTITION_MAIN = 'main';
const PARTITION_THD = 'thd';

const PROVIDERS_LIST = ['GoogleTHD', 'GoogleDirectTHD', "GoogleOpenBiddingTHD", 'GoogleDealsTHD','Admixer', 'Taboola', 'Ogury', 'ConnectAd', 'Sparteo', 'R2B2', 'Caroda', 'Nano', 'ADF_RRO', 'STG_RRO', 'RTBH_RRO', 'AGR_RRO', 'Teads_RRO', 'EQT_RRO', 'SW_RRO', 'Google_RRO', 'Google_OB_RRO', 'Google_Realitatea', 'Adform','Rubicon','Smart','Pubmatic','Xandr','GoogleADX', 'GoogleADX_Guaranteed', 'Google_2_ADX','Teads','Adpone','Criteo','RTBHouse','Agora','ONN', 'Seedtag', 'RichAudience', 'AdformTHD', 'TeadsTHD', 'RichAudienceTHD', 'LetThereBeAdsTHD', 'OrangeClickMediaTHD', "SparteoTHD", "OguryTHD", "OnnetworkTHD", "RTBHouseTHD", "SmartTHD", "ItaliaOnlineTHD", "WPartnerTHD"];
const RULE_TYPES = ['publisherName','websiteName','placementName','placementType','dealType','dealName', 'formatedDate', 'formatedViewability'];

const DATE_FORMAT = 'YYYY-MM-DD';

const PLACEMENT_TYPES = {
    'unknown': 'unknown',
    '2x2': 'unknown',
    '1x3': 'unknown',
    '3x3': 'unknown',
    'm320x100': 'm320x100',
    '320x100': '320x100',
    '300x100': '300x100',
    '320x50': 'm320x50',
    '300x50': 'm300x50',
    '300x60': 'm300x50',
    'm300x250': 'm300x250',
    'm300x600': 'm300x600', 
    '_300x250':'300x250',
    '300x250':'300x250',
    '320x250':'300x250', 
    '_300x600':'300x600',
    '300x600':'300x600',
    '320x180':'320x180', 
    '728x90':'728x90', 
    '160x600':'160x600',
    '120x600':'160x600', 
    '970x250':'970x250',
    '970x90':'970x250', 
    '1000x120':'970x250',
    '560x370':'560x370',
    '600x338':'InArticle',  
    'In-Article':'Out-stream',
    'In-Article Video':'Out-stream',
    'In_Article':'InArticle',
    'In-article':'Out-stream',
    'InArticle':'InArticle',
    '640x360':'Out-stream',
    'In-stream': 'In-stream',
    'instream':'In-stream',
    'Preroll':'In-stream',
    'preroll':'In-stream', 
    'Video - Linear':'In-stream',
    'Outstream':'Out-stream',
    'outstream':'Out-stream'
};

const UNIQUE_PLACEMENT_TYPES = Array.from(new Set(Object.values(PLACEMENT_TYPES)));

const BASE_URL = process.env.REACT_APP_ENV === 'production' ? '' : 'http://localhost:5000';

export {
    ONE_MONTH,
    ONE_DAY,
    TEN_MINUTES,
    ONE_HOUR,
    ONE_MINUTE,
    SERVER_TIME_DIFFERENCE,
    POSSIBLE_CHART_COLORS,
    ADMIN_ACCESS,
    PROVIDERS_LIST,
    RULE_TYPES,
    DATE_FORMAT,
    PERIOD_MACROS,
    UNIQUE_PLACEMENT_TYPES,
    PASSWORD_VALIDATION_CHECK,
    IMAGES_EXTENSIONS_CHECK,
    ADMIN_ACCESS_MASK,
    BASE_URL,
    NANO_AGREEMENT,
    PARTITION_MAIN,
    PARTITION_THD
}